module.exports = __webpack_public_path__ + "static/media/Logistic Provider Infographic - GBR network - 30-05-2024 C.61c7dd5a.gif";